import { makeAutoObservable } from 'mobx';
import { IEntityAPI, IEntityColumn, IGenericEntity, IUserConfigPackage, IVersion } from '../API';
import EntityDashboard from '../components/dashboards/EntityDashboard';

export default class VersionHistoryState {
	private entityId: string = '';

	public loading: boolean = false;
	public nextPageLink: string = '';
	public versions: IVersion[] = [];

	public visible: boolean = false;

	getApi: () => Promise<IEntityAPI<IGenericEntity>>;
	config: IUserConfigPackage;

	private columns: IEntityColumn[];

	constructor(
		userConfig: IUserConfigPackage,
		getApi: () => Promise<IEntityAPI<IGenericEntity>>,
		columns: IEntityColumn[],
	) {
		makeAutoObservable(this);
		this.getApi = getApi;
		this.config = userConfig;
		this.columns = columns;
	}

	public setVisible(visible: boolean) {
		this.visible = visible;
	}

	public async show(id: string) {
		this.entityId = id;

		this.loading = true;
		this.visible = true;

		let api = await this.getApi();
		let result = await api.versionHistory(this.entityId, this.nextPageLink);
		this.versions = result.versions.reverse();
		this.nextPageLink = result.nextPageLink;

		this.loading = false;
	}

	public getColumnDisplayName(internalName: string): string {
		var col = this.columns.find(
			(c) => c.id.toLowerCase() === internalName.toLowerCase(),
		);
		if (col?.displayName) {
			return col.displayName;
		} else {
			return internalName;
		}
	}

	public getFormattedValue(
		internalName: string,
		internalValue: string,
	): React.ReactNode | string {
		var col = this.columns.find(
			(c) => c.id.toLowerCase() === internalName.toLowerCase(),
		);
		if (col) {
			return EntityDashboard.displayPropertyValue(
				null,
				this.config,
				col,
				internalValue,
				true,
			);
		} else {
			return '';
		}
	}
}
